import Entity from '../../schema/Entity';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import FoodEstablishmentReservation from '../../schema/FoodEstablishmentReservation';
import setReservationEntityData from './setReservationEntityData';
import setRestaurantData from './setRestaurantData';
import tryCreateTxpOwaDate from './tryCreateTxpOwaDate';

/**
 * parse data for Food Reservation
 */
export default function setDiningEntityData(
    entity: Entity,
    diningEntity: any
): FoodEstablishmentReservation {
    if (entity && diningEntity) {
        if (isDiningEntityValid(diningEntity, entity)) {
            let newFoodReservationEntity: FoodEstablishmentReservation = setReservationEntityData(
                entity,
                diningEntity,
                true /* isReservationIdRequired */
            );

            newFoodReservationEntity = {
                ...newFoodReservationEntity,
                ...{
                    entityName: EntityTypeNames.FoodReservation,
                    entityType: EntityType.FoodReservation,
                    startTime: diningEntity.startTime,
                    startTimeUTC: diningEntity['startTime/utc'],
                    partySize: Number(diningEntity['partySize/excludingOrganizer']),
                    restaurantInfo: setRestaurantData(diningEntity),
                },
            };
            return newFoodReservationEntity;
        }
    }
    return null;
}

function isDiningEntityValid(diningEntity: any, entity: Entity) {
    if (
        diningEntity &&
        diningEntity.startTime &&
        tryCreateTxpOwaDate(diningEntity.startTime, entity) &&
        diningEntity.underName &&
        diningEntity.underName.name &&
        diningEntity.reservationFor &&
        diningEntity.reservationFor.name
    ) {
        return true;
    }

    return false;
}
